import useMarketSelectorDisplayedMarkets from 'src/components/MarketSelector/hooks/useMarketSelectorDisplayedMarkets';
import useMarketSelectorState from 'src/components/MarketSelector/hooks/useMarketSelectorState';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { ENUM_UTILS } from '@velocity-exchange/common';
import { MarketType } from '@velocity-exchange/sdk';

interface Params {
	marketType: MarketType;
}

export default function useMarketSelectorDropdown({ marketType }: Params) {
	const isMobileScreenSize = useIsMobileScreenSize();
	const currentMarketIsPerp = ENUM_UTILS.match(marketType, MarketType.PERP);

	const {
		searchValue,
		setSearchValue,
		selectedCategory,
		setSelectedCategory,
		sort,
		toggleSort,
		isFavoritesSticky,
		toggleIsFavoritesSticky,
	} = useMarketSelectorState({ currentMarketIsPerp });

	const displayedMarkets = useMarketSelectorDisplayedMarkets({
		selectedCategory,
		searchValue,
		sort,
		isFavoritesSticky,
	});

	return {
		displayedMarkets,
		searchValue,
		setSearchValue,
		selectedCategory,
		setSelectedCategory,
		sort,
		toggleSort,
		isMobileScreenSize,
		isFavoritesSticky,
		toggleIsFavoritesSticky,
	};
}
